<template>
  <div class="novu-inbox" ref="novuInbox"></div>
</template>

<script>
import { NovuUI } from "@novu/js/ui";

export default {
  name: "NovuInbox",
  data() {
    return {
      novuInstance: null,
      // Novu environment applicationIdentifier — must be set in .env
      // (VUE_APP_NOVU_APP_ID). No fallback on purpose: a missing value should
      // fail loudly (see the guard in initNovu) rather than silently pin the
      // bell to a hardcoded environment. .env is gitignored, so every machine
      // / build must set it — same as the VUE_APP_FIREBASE_* vars.
      novuAppId: process.env.VUE_APP_NOVU_APP_ID,
    };
  },
  mounted() {
    this.initNovu();
  },
  beforeDestroy() {
    this.destroyNovu();
  },
  watch: {
    "user.id"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.destroyNovu();
        this.$nextTick(() => {
          this.initNovu();
        });
      }
    },
  },
  methods: {
    initNovu() {
      if (!this.$refs.novuInbox) {
        console.error("Novu inbox container element not found");
        return;
      }

      if (!this.user || !this.user.id) {
        console.error("User not available");
        return;
      }

      if (!this.novuAppId) {
        console.error(
          "NovuInbox: VUE_APP_NOVU_APP_ID is missing from .env — the notification bell will not load."
        );
        return;
      }

      try {
        var novu = new NovuUI({
          options: {
            applicationIdentifier: this.novuAppId,
            subscriberId: String(this.user.id),
          },
          // appearance: {
          //   elements: {
          //     bellIcon: {
          //       color: "#ff9800", // Change bell color here
          //     },
          //   },
          // },
        });

        novu.mountComponent({
          name: "Inbox",
          props: {},
          element: this.$refs.novuInbox,
        });

        this.novuInstance = novu;
        // console.log("Novu Inbox mounted successfully for user:", this.user.id);
      } catch (error) {
        console.error("Failed to initialize Novu inbox:", error);
      }
    },
    destroyNovu() {
      if (this.novuInstance && this.$refs.novuInbox) {
        try {
          this.novuInstance.unmountComponent(this.$refs.novuInbox);
        } catch (error) {
          // Ignore unmount errors
        }
        this.novuInstance = null;
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters["global/profile"];
    },
  },
};
</script>


<style lang="scss">
.novu-inbox {
  margin-top: 7px;
  .nv-popoverContent {
    direction: ltr !important;
  }
}

// Global styles for Novu popover (rendered in portal)
:global {
  .nv-popoverContent,
  .nv-root,
  [data-novu-popover],
  [class*="nv-"] {
    z-index: 99999 !important;
  }
}
</style>
